import React from 'react';
import {ARE_YOU_SHURE_MSG, ARE_YOU_SHURE_TITLE, NO, YES} from "../i18n/i18n";

export default function ConfirmDeleteForm (props) {
    return <div className='custom-ui'>
        <h1>{ARE_YOU_SHURE_TITLE}</h1>
        <p>{ARE_YOU_SHURE_MSG}</p>
        <button onClick={props.onClose}>{NO}</button>
        <button className={"btn-alert-delete"} onClick={() => {
            props.deleteItem(props.data)
            props.onClose();
        }}>
            {YES}
        </button>
    </div>
}